import React, { useState, useEffect } from 'react';
import  './slider.css';
import '../eventMenu/event.css'
import {getLabelMinute, setFullscreen} from "../../globalMethods/utils";
import {Button, Card, Col, Row} from "react-bootstrap";
import Replay10Icon from "@mui/icons-material/Replay10";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Forward10RoundedIcon from "@mui/icons-material/Forward10Rounded";
import {Slider, Stack, useMediaQuery, useTheme} from "@mui/material";
import CropFreeOutlinedIcon from "@mui/icons-material/CropFreeOutlined";
import {VolumeDown, VolumeUp} from "@mui/icons-material";
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import UHDPlayer from "./UHDPlayer";
import AlignItemsList from "../eventMenu/eventItem";
import userSessionChecker from "../check/checker";

function SeekSlider({ player, showBarMenu, channelsInfo, showTimerBarEvent, chanelLogo, userCode }) {

    const [programmTitle, setProgrammTitle] = useState("");
    const [programmSubTitle, setProgrammSubTitle] = useState("");

    const [cursor] = useState("none");
    const [logoUrl, setLogoUrl] = useState("");

    const [event, setEvent] = useState({  });

    const [programmStart, setProgrammStart] = useState("");
    const [programmEnd, setProgrammEnd] = useState("");
    const [volume, setVolume] = useState(0);

    const [min, setMin] = useState(0.0)
    const [max, setMax] = useState(100.0)

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));


    const [eventsProgressL, setEventsProgressL] = useState(0);
    useEffect(() => {
        if (!player) {
            return;
        }

        const onEventPlayer = (streamEvent) =>{
            console.log(streamEvent)
        }

        const onPositionUpdate = async () => {
            let eventLayout ={}


            //await userSessionChecker(userCode)

            for (let event of channelsInfo?.events){
                const startingDate = new Date(Date.parse(event?.startDate))
                const endingDate = new Date(Date.parse(event?.endDate))
                const wallClockTime = player.getWallClockTime();
                const startingDateInSecond = startingDate.getTime() / 1000
                const endingDateInSecond = endingDate.getTime() / 1000

                if(( startingDateInSecond < wallClockTime) && (endingDateInSecond > wallClockTime)){
                    setMin(startingDateInSecond)
                    setMax(endingDateInSecond)
                    eventLayout = event
                    setEvent(event)
                    const startString = getLabelMinute(startingDate)
                    const endString = getLabelMinute(endingDate)
                    setProgrammEnd(endString)
                    setProgrammStart(startString)
                    const logoUrl = eventLayout.picture?.replace("{resolutionXY}","170x95/filters:quality(80)")
                    setLogoUrl(logoUrl)
                    setProgrammTitle(eventLayout.title)
                    setProgrammSubTitle(eventLayout?.subTitle)
                    setEventsProgressL(wallClockTime)
                    break
                }
            }
        };

        player.addEventListener('positionUpdate', onPositionUpdate);

        return () => {
            player.removeEventListener('positionUpdate', onPositionUpdate)
            player.removeEventListener('streamEvent', onEventPlayer)
        };
    }, [player, channelsInfo.events]);

    const getCurrentPlayingTime = (value) => {
        const availableImageTrack = player?.getImageTrackData();
        console.log(availableImageTrack)
        const timerMillisecond = value * 1000;
        const dateCurrentTime = new Date(timerMillisecond)
        return getLabelMinute(dateCurrentTime)
    }

    return (
        <>

            {
                showBarMenu ? <div className={"show-menu-history"}>
                        <AlignItemsList eventShows={ channelsInfo?.events} player={player} playingEvent={event}></AlignItemsList>

                </div> : <></>
                }
            {
                showBarMenu ? <div>

                        <div className={"card-bar-up-volume"}>
                            <Stack spacing={2} direction="row" sx={{mb: 3, ml: 2}} alignItems="center">
                                {
                                    player?.isMute()? <VolumeOffIcon onClick={()=> {
                                            player?.unMute();
                                        }} sx={{color: "white", fontSize: isDesktop? 40 : 20}}/>
                                        : <VolumeDown onClick={()=> {
                                            player.mute();
                                        }}  sx={{color: "white", fontSize: isDesktop? 40 : 20}}/>

                                }
                                <Slider aria-label="Volume" value={volume}
                                        onChange={(event, newValue) => {
                                            //this.setState({value: newValue})
                                            if(player?.isMute()) {
                                                player?.unMute();
                                            }
                                            player?.setVolume(newValue / 100.0)
                                            setVolume(newValue)
                                        }}/>
                                <VolumeUp sx={{color: "white", fontSize:  isDesktop? 40 : 20}}/>
                            </Stack>
                        </div>

                        <div onMouseOver={()=>{
                            showTimerBarEvent()
                        }} className={"card-title-down-menu"}>
                            <Stack spacing={2} style={{fontFamily: "Orbitron", fontSize: isDesktop? 20 : 10, color: "white"}}
                                   direction="row" sx={{mb: 3, ml: 2}} alignItems="center">
                                {
                                    logoUrl !== undefined ?
                                        <img style={{maxWidth: 100, maxHeight: 120, borderRadius: 2}} loading={"lazy"}
                                             alt={programmTitle}
                                             src={logoUrl}/>
                                        : <>
                                            <img style={{maxWidth: 100, maxHeight: 120, bottom:40, borderRadius: 2}} loading={"lazy"}
                                                 alt={programmTitle}
                                                 src={chanelLogo}/>
                                        </>
                                }

                                <Stack spacing={2}
                                       style={{
                                           fontFamily: "Orbitron",
                                           fontWeight: "bold",
                                           fontSize: isDesktop? 20 : 10,
                                           color: "white"
                                       }}
                                       direction="column" sx={{mb: 3, ml: 2}} alignItems="start">
                                    <label>{programmTitle}</label>
                                    <label>{programmSubTitle}</label>
                                </Stack>

                            </Stack>
                        </div>
                    </div>
                    : <div style={{cursor:cursor}}>
                    </div>

            }
            {
                showBarMenu  ? <Card className="card-bar-down-menu">
                    <Card.Body>

                        <Row style={{ marginBottom:20, marginLeft:20, with:"100%", marginTop:20, fontFamily: "Orbitron"}}>
                            <Col md={2}>
                                <Row>
                                    <Col>
                                        <Replay10Icon sx={{color: "white", fontSize: isDesktop? 40 : 20}} onClick={() => {
                                            player?.seekTo({relative: -10})
                                        }}></Replay10Icon>
                                    </Col>
                                    <Col>
                                        {
                                            player?.getPlayerState() === "PLAYING" ?
                                                <PauseIcon sx={{color: "white", fontSize: isDesktop? 40 : 20}}
                                                           onClick={() => {
                                                               player?.pause()
                                                           }}></PauseIcon> :
                                                <PlayArrowIcon sx={{color: "white", fontSize: isDesktop? 40 : 20}}
                                                               onClick={() => {
                                                                   player?.play()
                                                               }}></PlayArrowIcon>

                                        }
                                    </Col>
                                    <Col>
                                        <Forward10RoundedIcon sx={{color: "white", fontSize: isDesktop? 40 : 20}}
                                                              onClick={() => {
                                                                  player?.seekTo({relative: 10})
                                                              }}></Forward10RoundedIcon>
                                    </Col>
                                </Row>
                            </Col>
                            <Col style={{marginTop: 5, display: "inline-block"}} md={8}>
                                <Row>
                                    <Col xs={1}> <label style={{
                                        color: "white",
                                        fontSize:isDesktop? 20:10
                                    }}>{programmStart}</label></Col>
                                    <Col xs={10}>
                                        <Slider min={min} max={max} onChange={(event, newValue) => {
                                            const nowTime = Date.now() / 1000
                                            const  minMinimum =  nowTime - 28800

                                            if (newValue > minMinimum){
                                                if (newValue < nowTime) {
                                                    player?.seekTo({wallClockTime: newValue});
                                                }
                                            }
                                            else {
                                                player?.seekTo({ position: player?.getMinimumPosition() + 5 });
                                            }
                                        }} valueLabelDisplay={"auto"} valueLabelFormat={getCurrentPlayingTime} getAriaValueText={getCurrentPlayingTime} value={eventsProgressL}></Slider>
                                    </Col>
                                    <Col xs={1}> <label style={{
                                        color: "white",
                                        fontSize:isDesktop? 20:10
                                    }}>{programmEnd}</label></Col>
                                </Row>
                            </Col>
                            <Col md={2}>
                                <Button onClick={() => {
                                    const liveTime = (Date.now() /1000 ) - 3
                                    //player?.seekTo({ position: player?.getLivePosition() + 5 });
                                    player?.seekTo({wallClockTime: liveTime});
                                }} style={{marginRight: 20}}>
                                    Direct
                                </Button>

                                <CropFreeOutlinedIcon id ="toggleFullscreenButton" sx={{color: "white", fontSize: isDesktop? 40 : 20}}
                                                      onClick={async () => {
                                                          await setFullscreen()
                                                      }}></CropFreeOutlinedIcon>


                                <UHDPlayer player={player}></UHDPlayer>

                            </Col>
                        </Row>
                    </Card.Body>
                </Card> : <div style={{cursor: "none"}}></div>
            }
        </>

    );
}

export default SeekSlider;